// import external dependencies
import 'jquery';

// Import everything from autoload
;

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import gallery from './routes/gallery';
import studio from './routes/studio';
import contact from './routes/contact';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  gallery,
  studio,
  contact,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
